/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Mitigation from '@linc-technologies/linced-common/models/events/mitigation';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: events.Risk.
export default class Risk extends Model {
  declare [Type]: 'events/risk';

  // createTime is when the resource was created in seconds from the epoch.
  @attr('number')
  declare createTime: number | undefined;

  // updateTime is the last time the resource was modified in seconds from
  // the epoch.
  @attr('number')
  declare updateTime: number | undefined;

  // schoolId is the school the risk is assigned to.
  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @alias('school.id')
  declare school_id: string | null | undefined;

  // label is the label to describe the risk
  @attr('string', { defaultValue: '' })
  declare label: string;

  // content is the content within the risk
  @attr('string', { defaultValue: '' })
  declare content: string;

  @attr('boolean', { defaultValue: false })
  declare inUse: boolean;

  @hasMany('events/mitigation', { async: true, inverse: null })
  declare mitigationIds: AsyncHasMany<Mitigation>;

  @alias('mitigationIds')
  declare mitigations: AsyncHasMany<Mitigation>;

  // mitigations is an async hasMany -- mapBy on its PromiseManyArray is
  // deprecated (and triggers the "Do not use A()" deprecation via its
  // internal array-observer setup), so walk it with the safe `forEach`.
  @computed('mitigations.[]')
  get mitigation_ids() {
    const ids: (string | null)[] = [];
    this.mitigations.forEach((mitigation) => ids.push(mitigation.id));
    return ids;
  }
}
